export var AssetStatusType;
(function (AssetStatusType) {
    AssetStatusType["Unprepared"] = "Unprepared";
    AssetStatusType["Preparing"] = "Preparing";
    AssetStatusType["Prepared"] = "Prepared";
    AssetStatusType["Deleting"] = "Deleting";
    AssetStatusType["Deleted"] = "Deleted";
    AssetStatusType["Error"] = "Error";
    AssetStatusType["SignedUrlError"] = "SignedUrlError";
    AssetStatusType["Hidden"] = "Hidden";
})(AssetStatusType || (AssetStatusType = {}));
export var AssetErrorMessage;
(function (AssetErrorMessage) {
    AssetErrorMessage["PresignFailed"] = "Couldn't presign asset";
    AssetErrorMessage["PrepareDeletingAsset"] = "Can't prepare asset when it's being deleted";
    AssetErrorMessage["PrepareDeletedAsset"] = "Can't prepare an asset that has been deleted";
    AssetErrorMessage["EmptySignature"] = "Signature is empty or does not exist";
    AssetErrorMessage["InvalidSourceData"] = "Invalid asset source data";
    AssetErrorMessage["MissingAssetId"] = "Missing asset ID";
    AssetErrorMessage["PatchUnpreparedAsset"] = "Can't patch an unprepared asset";
    AssetErrorMessage["AssetNotFound"] = "Asset with specified metadata could not be found";
    AssetErrorMessage["AssetUploadSignedUrl"] = "Uploading Asset using signed URL fails";
})(AssetErrorMessage || (AssetErrorMessage = {}));
//# sourceMappingURL=types.js.map